<template>

  <span style="cursor:pointer;" @click="openModal()" >{{ productN.name }}</span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
상품 수정

  </div>
  <div class="modal-body">
    <table class="table">
      <tbody>
        <tr>
          <th>상품22코드</th>
          <td style="text-align:center;">자동생성</td>
          <td>사용여부</td>
          <td>
            <select class="hidtype" :value="nvl(changedData.active, Tsub.active)"
                :class="{'hidtype-changed': changedData.active}"
                @input="doChange('active', $event.target.value)">
                <option value="1">사용</option>
                <option value="0">미사용</option>
              </select>
              <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.active"
                @click="delete changedData.active"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
        <tr>
          <th>상품명</th>
          <td colspan="3"><input class="hidtype" style="width:90%;" :value="changedData.name || Tsub.name"
              :class="{'hidtype-changed': changedData.name}"
              @input="doChange('name', $event.target.value)" placeholder="상품명" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.name"
              @click="delete changedData.name"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
        <tr>
          <th>상품유형</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.product, Tsub.product)"
                              :class="{'hidtype-changed': changedData.product}"
                              @input="doChange('product', $event.target.value)">
              <option selected value="ChildU">ChildU</option>
              <option value="MYPATH">MYPATH</option>
              <option value="ChildUM">ChildU(M)</option>
            </select>
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.product"
            @click="dataDelete('product')"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <th>상품개월</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.period, Tsub.period)"
                              :class="{'hidtype-changed': changedData.period}"
                              @input="doChange('period', $event.target.value)">
              <option selected value="1">1개월</option>
              <option value="2">2개월</option>
              <option value="3">3개월</option>
            </select>
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.period"
                              @click="delete changedData.period"><i class="bi bi-arrow-counterclockwise"></i></button>
        </td>
        </tr>
        <tr>
          <th>판매가</th>
          <td><input class="hidtype" :value="changedData.price || Tsub.price"
                          :class="{'hidtype-changed': changedData.price}"
                          @input="doChange('price', $event.target.value)" placeholder="판매가" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.price"
                          @click="delete changedData.price"><i class="bi bi-arrow-counterclockwise"></i></button>&nbsp;원</td>
          <th>판매수수료</th>
          <td><input class="hidtype" :value="changedData.retail_margin || Tsub.retail_margin"
                          :class="{'hidtype-changed': changedData.retail_margin}"
                          @input="doChange('retail_margin', $event.target.value)" placeholder="판매수수료" />
                        <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.retail_margin"
                          @click="delete changedData.retail_margin"><i class="bi bi-arrow-counterclockwise"></i></button>&nbsp;원</td>
        </tr>
        <tr>
          <th>북클럽</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.bookclubs, Tsub.bookclubs)"
                              :class="{'hidtype-changed': changedData.bookclubs}"
                              @input="doChange('bookclubs', $event.target.value)">
                  <option selected>선택</option>
                  <option value="1">사용</option>
                  <option value="0">미사용</option>
                </select>
                <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bookclubs"
                              @click="delete changedData.bookclubs"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <th>보카조아</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.vocajoa, Tsub.vocajoa)"
                              :class="{'hidtype-changed': changedData.vocajoa}"
                              @input="doChange('vocajoa', $event.target.value)">
                  <option selected>선택</option>
                  <option value="1">사용</option>
                  <option value="0">미사용</option>
                </select>
                <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.vocajoa"
                              @click="delete changedData.vocajoa"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
        <tr>
          <th>노출그룹</th>
          <td>
            <input class="hidtype" style="width:90%;" :value="changedData.buyPermission || Tsub.buyPermission"
              :class="{'hidtype-changed': changedData.buyPermission}"
              @input="doChange('buyPermission', $event.target.value)" placeholder="노출그룹" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.buyPermission"
              @click="delete changedData.buyPermission"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <template v-if="Tsub.subject || this.childum_chk">
            <th><template v-if="this.childum_chk">과목수량</template></th>
                      <td><template v-if="this.childum_chk">
                        <select
                          class="hidtype"
                          :value="nvl(changedData.subject, Tsub.subject)"
                          :class="{ 'hidtype-changed': changedData.subject }"
                          @input="doChange('subject', $event.target.value)"
                        >
                          <option selected>선택</option>
                          <option value="1">1과목</option>
                          <option value="2">2과목</option>
                          <option value="3">3과목</option>
                          <option value="4">4과목</option>
                        </select>
                        <button
                          class="btn btn-sm btn-danger"
                          style="display: inline"
                          v-if="changedData.subject"
                          @click="dataDelete('subject')"
                        >
                          <i class="bi bi-arrow-counterclockwise"></i>
                        </button></template>
                      </td>
          </template>
          <template v-else>
          <th></th>
          <td>
          </td>
          </template>
        </tr>
        <tr>
          <th>메모</th>
          <td colspan="3">

            <input class="hidtype" :value="changedData.memo || Tsub.memo"
              :class="{'hidtype-changed': changedData.memo}"
              @input="doChange('memo', $event.target.value)" style="width:90%;" placeholder="상품에 특별한 내용이 있을경우에만 입력해주세요." />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.memo"
              @click="delete changedData.memo"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
<div class="flex_center">
    <button type="button" class="btn btn-danger" @click="doSend()">수정</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> Close</button>
  </div>
  </div></div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    "name": "productN",
    components: {

    },
    methods: {
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      openModal() {
        this.active = true;
        if(this.productN.product==="ChildUM"){
        this.childum_chk = true;
        }else{
          this.childum_chk = false;
        }
        this.modifyMode(this.productN)
        //console.log(this.Tsub.bookclubs);
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(modalDom);
          modal.show();

        });
      },
      doChange(name, value) {
        if (this.Tsub[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
          if( name === "product"){
          this.changedData['subject'] = "";
          if ( value === "ChildUM" ) {       
          this.childum_chk = true;        
          }else {
          this.childum_chk = false;
          }
        }
      },
      dataDelete(name){
      
      if(name==="product"){
        delete this.changedData[name];
        if(this.Tsub.product ==="ChildUM"){
        this.childum_chk = true;         
        this.modifyMode(this.productN);        
        }else{
          this.childum_chk = false; 
        }
      }else{
        this.changedData[name] = "";
      }
    },
      modifyMode(record){
        this.creating = false;
        
        this.changedData = {};
        this.Tsub =  {
          "id": record.id,
          "active": record.active,
          "name": record.name,
          "product": record.product,
          "period": record.period,
          "price": record.price,
          "subject": record.subject,
          "retail_margin": record.retail_margin,
          "bookclubs": record.bookclubs,
          "vocajoa": record.vocajoa,
          "buyPermission": record.buyPermission,
          "memo": record.memo
        }
        if(this.Tsub.product === "ChildUM"){
          this.changedData.product = this.Tsub.product;
          this.changedData.subject = this.Tsub.subject;
        }
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        //console.log("product:"+this.changedData.product);
        //console.log("subject:"+this.changedData.subject);
       
        if(this.changedData.product === "ChildUM"){

          if(this.changedData.subject === "" ){
            alert("과목수량을 선택해주세요.");
            return;
          }
      }

      
        var data = this.changedData;
        console.log("data:"+JSON.stringify(data));
        //return;



        var send = {
          method: this.creating ? "post" : "patch",
          url: '/product_manage' + "/" + this.Tsub.id,
          data: data
        };

        //console.log(this.selBiz);
        //return;

            if(!this.active){
                //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
                $.notify({
                  // options
                  message: '사용유무를 지정하셔야 합니다. '
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
                return;
            }

          if(Object.keys(this.changedData).length){

          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              //this.$refs.qg.search()
              this.$parent.search();
              (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
            }


          })

          }


      }
    },
        mounted() {
      this.Tsub = this.productN;
      if(this.Tsub.product === "ChildUM"){
        this.childum_chk = true;
      }else{
        this.childum_chk = false;
      }
      //console.log(this.Tsub.bookclubs);
    },
    watch: {
      sub(){
        alert('tsub has been updated')
              this.Tsub = this.productN;
      }
    },
    props: {
      productN: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
            creating: false,
            active: false,
            Tsub: {
              "name": "",
              "active": "",
              "product": "",
              "period": "",
              "price": "",
              "retail_margin": "",
              "bookclubs": "",
              "vocajoa": "",
              "buyPermission": "",
              "memo": ""
            },
            changedData: {
              "name": "",
              "active": "",
              "product": "",
              "period": "",
              "price": "",
              "retail_margin": "",
              "bookclubs": "",
              "buyPermission": "",
              "vocajoa": "",
              "memo": ""
            },
            product: null
        }
    }
}
</script>

<style>

</style>
